var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center margin-top-50 padding-left-right"},[_c('i',{staticClass:"el-icon-success",staticStyle:{"font-size":"100px","color":"green"}}),_c('div',{staticClass:"f16 padding-top-bottom-40"},[_vm._v("登录成功")])])
}]

export { render, staticRenderFns }